import { frontendURL } from 'dashboard/helper/URLHelper';

const AgendamentoIndex = () => import('./pages/AgendamentoIndex.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/agendamento'),
      name: 'agendamento_index',
      component: AgendamentoIndex,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
